import Vue, { VNode } from 'vue';
import './registerComponents';
import App from './App.vue';
import { installApiPlugin } from 'shared/api';
import installAnalyticsPlugin from 'shared/utils/analytics/analytics-plugin';
import installTippyPlugin from 'shared/directives/tippy';
import currencyFilter from 'shared/filters/currency.filter';
import emitter from '@/egrn-order/emitter';

Vue.config.productionTip = false;

Vue.use(installApiPlugin);
Vue.use(currencyFilter);
Vue.use(installTippyPlugin, {
  animateFill: false,
  theme: 'light',
  arrow: true,
  a11y: false,
});
Vue.use(installAnalyticsPlugin({
  yandexCounters: [ '48408542' ],
  gtagId: 'UA-122176305-1',
}));

const el = document.querySelector('[data-realtycloud-egrn-form="free"]');

if (el) {
  const formType = el.getAttribute('data-form-type') || 'advanced';
  const vm = new Vue({
    render: (h): VNode => h(App, { props: { formType } }),
  }).$mount(el);

  emitter.emit('init', { vm, Vue });
}
